export default __webpack_public_path__ + "static/media/EXCELSOFT.af4f1d49.png";